import type { KeyboardEvent } from "react";
import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";

interface OnlineTestIntroInputProps {
    value: string;
    onChange: (value: string) => void;

    onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
    placeholder?: string;
    "data-testid"?: string;
}

const OnlineTestIntroInput = (props: OnlineTestIntroInputProps) => {
    return (
        <label className="w-full p-s gap-xs bg-white border border-p6-grey-lightest rounded flex flex-row items-center justify-center cursor-pointer overflow-hidden">
            <div className="w-m h-m flex shrink-0 justify-center items-center">
                <PhaseSixIcon
                    name="edit-avatar"
                    className="text-xxl text-p6-grey-mid"
                />
            </div>

            {/* Size adapts to content length so the input stays horizontally centered in the flex container */}
            <input
                type="text"
                value={props.value}
                onChange={(event) => props.onChange(event.target.value)}
                onKeyDown={props.onKeyDown}
                placeholder={props.placeholder}
                aria-label={props.placeholder}
                data-testid={props["data-testid"]}
                size={props.value.length || props.placeholder?.length || 10}
                className="text-l text-p6-grey-dark placeholder:text-p6-grey-mid focus:outline-none bg-transparent min-w-0"
            />
        </label>
    );
};

export default OnlineTestIntroInput;
